<div
  class="dropdown"
  [ngClass]="settings.containerClasses"
  [class.open]="isVisible">
  <button
    type="button"
    class="dropdown-toggle"
    [ngClass]="settings.buttonClasses"
    (click)="toggleDropdown()"
    (keydown.enter)="toggleDropdown()"
    [disabled]="disabled"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false">
    {{ title }}<span class="caret"></span>
  </button>
  @if (isVisible) {
    <div
      #scroller
      class="dropdown-menu"
      (scroll)="settings.isLazyLoad ? checkScrollPosition($event) : null"
      (wheel)="
        settings.stopScrollPropagation
          ? checkScrollPropagation($event, scroller)
          : null
      "
      [class.pull-right]="settings.pullRight"
      [class.dropdown-menu-right]="settings.pullRight"
      [style.max-height]="settings.maxHeight"
      style="display: block; height: auto; overflow-y: auto">
      @if (settings.enableSearch) {
        <div class="dropdown-item search">
          <div class="input-group input-group-sm">
            <input
              type="text"
              class="form-control"
              placeholder="{{ texts.searchPlaceholder }}"
              aria-describedby="sizing-addon3"
              [formControl]="filterControl" />
            @if (filterControl.value.length > 0) {
              <span class="input-group-btn">
                <button
                  class="btn btn-default btn-secondary"
                  type="button"
                  (click)="clearSearch($event)"
                  (keydown.enter)="clearSearch($event)">
                  <i class="fa fa-times"></i>
                </button>
              </span>
            }
          </div>
        </div>
      }
      @if (settings.showCheckAll && !disabledSelection) {
        <a
          class="dropdown-item"
          (click)="checkAll()"
          (keydown.enter)="checkAll()"
          ><span style="width: 16px" class="fa fa-check"></span>
          {{ texts.checkAll }}</a
        >
      }
      @if (settings.showCheckAll && !disabledSelection) {
        <a
          class="dropdown-item"
          (click)="uncheckAll()"
          (keydown.enter)="uncheckAll()"
          ><span style="width: 16px" class="fa fa-times"></span>
          {{ texts.uncheckAll }}</a
        >
      }
      @if (settings.showCheckAll || settings.showUncheckAll) {
        <div class="dropdown-divider"></div>
      }
      @if (!renderItems) {
        <div class="dropdown-item empty">{{ texts.searchNoRenderText }}</div>
      }
      @if (renderItems && !renderFilteredOptions.length) {
        <div class="dropdown-item empty">{{ texts.searchEmptyResult }}</div>
      }
      @for (option of renderFilteredOptions; track option) {
        <div
          [ngStyle]="getItemStyle(option)"
          [ngClass]="option.classes"
          [class.dropdown-header]="option.isLabel">
          @if (!option.isLabel) {
            <a
              class="dropdown-item"
              (click)="setSelected($event, option)"
              (keydown.enter)="setSelected($event, option)"
              [style.padding-left]="
                this.parents.length > 0 &&
                this.parents.indexOf(option.id) < 0 &&
                '30px'
              "
              [ngStyle]="getItemStyleSelectionDisabled()">
              <span style="width: 16px; display: inline-block">
                @if (isSelected(option)) {
                  <i class="fa fa-check" aria-hidden="true"></i>
                }
              </span>
              <span
                [ngClass]="settings.itemClasses"
                [style.font-weight]="
                  this.parents.indexOf(option.id) >= 0 ? 'bold' : 'normal'
                ">
                {{ option.name }}
              </span>
            </a>
          } @else {
            {{ option.name }}
          }
        </div>
      }
    </div>
  }
</div>
